'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringTemplate = require('string-template');

var _stringTemplate2 = _interopRequireDefault(_stringTemplate);

var _utils = require('../../utils');

var _icons = require('../icons');

var _icons2 = _interopRequireDefault(_icons);

var _progress = require('./progress');

var _progress2 = _interopRequireDefault(_progress);

var _tpl = require('./tpl');

var _tpl2 = _interopRequireDefault(_tpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ControlBar = function () {
  function ControlBar(elVideo, options) {
    _classCallCheck(this, ControlBar);

    this.elVideo = elVideo;
    this.elContainer = this.elVideo.parentNode;
    this.options = options || {};
    this.conSize = {};

    this.init = this.init.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
    this.updateVolume = this.updateVolume.bind(this);
    this.fullScreenChange = this.fullScreenChange.bind(this);
    this.IeFullScreenChange = this.IeFullScreenChange.bind(this);

    this.render();
  }

  ControlBar.prototype.render = function render() {
    var _this = this;

    var tplData = {};
    Object.keys(_icons2['default']).forEach(function (key) {
      return tplData['icon_' + key] = _icons2['default'][key];
    });

    this.element = (0, _utils.createElement)((0, _stringTemplate2['default'])(_tpl2['default'], tplData));
    this.elCurTime = this.element.querySelector('.current-time');
    this.elTotalTime = this.element.querySelector('.total-time');
    this.elPlay = this.element.querySelector('.play-button');
    this.elFullscreen = this.element.querySelector('.fullscreen-button');
    this.elVolume = this.element.querySelector('.volume-button');
    if (this.elVideo.muted) {
      this.elVolume.innerHTML = _icons2['default'].volumeoff;
    }

    this.progressBar = new _progress2['default'](this.element.querySelector('.progress-bar'), 0);
    this.volumeBar = new _progress2['default'](this.element.querySelector('.volume-bar'), 1);

    if (this.options.showControlBar === 'always') {
      (0, _utils.addClassName)(this.element, 'show');
    }
    // 初始把全屏按钮置灰，等视频loadedmetadata后再把按钮置成白色
    (0, _utils.addClassName)(this.element, 'forbid-fullscreen');
    (0, _utils.once)(this.elVideo, 'loadedmetadata', function () {
      if ((0, _utils.isFullScreenEnabled)(_this.elContainer)) {
        (0, _utils.removeClassName)(_this.element, 'forbid-fullscreen');
      }
    });
    this.elVideo.parentNode.appendChild(this.element);

    // 播放暂停要在init的时候监听，因为播放事件可以在别的地方触发
    this.elPlay.addEventListener('click', function () {
      if (_this.elVideo.paused) {
        _this.elVideo.play();
      } else {
        _this.elVideo.pause();
      }
    });
    this.elVideo.addEventListener('play', function () {
      _this.elPlay.innerHTML = _icons2['default'].pause;
      // 播放时设置一次进度，避免end后重新播放进度更新不及时
      _this.updateProgress(false);
    });
    this.elVideo.addEventListener('pause', function () {
      return _this.elPlay.innerHTML = _icons2['default'].play;
    });

    if (this.elVideo.duration) {
      this.init();
    } else {
      (0, _utils.once)(this.elVideo, 'loadedmetadata', this.init);
    }
  };

  ControlBar.prototype.init = function init() {
    var _this2 = this;

    this.elTotalTime.innerHTML = '' + (0, _utils.formatTime)(this.elVideo.duration);

    this.bindEvents();

    this.progressBar.onChange = function (value) {
      // 注意要取小于等于duration的正整数，否则ie会异常无法再播放
      _this2.elVideo.currentTime = Math.floor(_this2.elVideo.duration * value);
    };
    this.progressBar.init();

    this.volumeBar.onChange = function (value) {
      _this2.elVideo.volume = value;
    };
    this.volumeBar.init();
  };

  ControlBar.prototype.bindEvents = function bindEvents() {
    var _this3 = this;

    // 进度更新
    this.elVideo.addEventListener('timeupdate', this.updateProgress);

    // 全屏
    (0, _utils.onFullScreenChange)(this.elContainer, this.fullScreenChange);
    // ie11全屏事件只在document上可用
    if (document.msFullscreenEnabled) {
      document.addEventListener('MSFullscreenChange', this.IeFullScreenChange);
    }
    this.elFullscreen.addEventListener('click', function () {
      if ((0, _utils.isFullScreen)(_this3.elContainer)) {
        (0, _utils.exitFullScreen)(_this3.elContainer);
        return;
      }
      _this3.conSize.width = _this3.elContainer.style.width;
      _this3.conSize.height = _this3.elContainer.style.height;
      (0, _utils.requestFullscreen)(_this3.elContainer);
    });

    // 静音
    this.elVolume.addEventListener('click', function () {
      if (_this3.elVideo.muted) {
        _this3.elVideo.muted = false;
        _this3.elVolume.innerHTML = _icons2['default'].volume;
      } else {
        _this3.elVideo.muted = true;
        _this3.elVolume.innerHTML = _icons2['default'].volumeoff;
      }
    });

    // 音量更新
    this.elVideo.addEventListener('volumechange', this.updateVolume);
  };

  ControlBar.prototype.updateProgress = function updateProgress(throttle) {
    if (throttle && Math.abs(this.elVideo.currentTime - this._currentTime) < 0.5) {
      return;
    }
    this._currentTime = this.elVideo.currentTime;

    this.progressBar.setProgress(this._currentTime / this.elVideo.duration);
    this.elCurTime.innerHTML = '' + (0, _utils.formatTime)(this._currentTime);
  };

  ControlBar.prototype.updateVolume = function updateVolume() {
    if (this.elVideo.muted || Math.abs(this.elVideo.volume - this._currentVolume) < 0.05) {
      return;
    }
    this._currentVolume = this.elVideo.volume;
    this.volumeBar.setProgress(this._currentVolume);
  };

  ControlBar.prototype.fullScreenChange = function fullScreenChange() {
    if ((0, _utils.isFullScreen)(this.elContainer)) {
      this.elContainer.style.width = '100%';
      this.elContainer.style.height = '100%';
      this.elFullscreen.innerHTML = _icons2['default'].exitfullscreen;
      return;
    }
    this.elFullscreen.innerHTML = _icons2['default'].fullscreen;
    this.elContainer.style.width = this.conSize.width;
    this.elContainer.style.height = this.conSize.height;
  };

  ControlBar.prototype.IeFullScreenChange = function IeFullScreenChange() {
    if ((0, _utils.isFullScreen)(this.elContainer) && document.msFullscreenElement !== this.elContainer) {
      return;
    }
    this.fullScreenChange();
  };

  ControlBar.prototype.destroy = function destroy() {
    document.removeEventListener('MSFullscreenChange', this.IeFullScreenChange);
  };

  return ControlBar;
}();

exports['default'] = ControlBar;
module.exports = exports['default'];